import { createSlice } from '@reduxjs/toolkit';
const initialState ={};
const dataSlice = createSlice({
  name: 'data',
  initialState,
  reducers: {
    updateGiftOrderData: (state, action) => {
      return action.payload;
    },
  },
});
export const { updateGiftOrderData } = dataSlice.actions;
export const getGiftOrderData = (state) => state.updateGiftOrderData;
export default dataSlice.reducer;